import { IPersonProfessionData, IPersonalData, IUserInitialQuizData } from "@interfaces/initial-quiz/initial-quiz";
import initialQuizApiInstance from "@services/clients/initial-quiz";

export async function getUserInitialQuizData(token?: string)
{
    const endpoint = "/practitioner/initial-quiz";
    const options = token ? {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    } : {};
    const res = await initialQuizApiInstance.get<IUserInitialQuizData>(endpoint, options);
    return res.data;
}

export async function savePersonProfession(data: IPersonProfessionData)
{
    const endpoint = "/practitioner/initial-quiz/person-profession";
    const res = await initialQuizApiInstance.post<IUserInitialQuizData>(endpoint, data);
    return res.data;
}

export async function savePersonalData(data: IPersonalData)
{
    const endpoint = "/practitioner/initial-quiz/personal-data";
    const res = await initialQuizApiInstance.post<IUserInitialQuizData>(endpoint, data);
    return res.data;
}

export async function finalizeInitialQuiz()
{
    const endpoint = "/practitioner/initial-quiz/finalize";
    const res = await initialQuizApiInstance.put(endpoint);
    return res.status;
}
